/**
 * Method to call privacy
 * @param {*} form 
 * @param {*} ProfileService
 */
let callOrderPrivacy = (form, ProfileService)=>{
    let data;
    if (form.isMember) {
        data = {
            'D-1': form.sponsor? 0 : 1,
            'D-2': form.group? 0 : 1,
            'D-3': form.upline? 0 : 1
        }
    } else {
        data = {
            'D-1': form.sponsor? 0 : 1
        }
    }
    ProfileService.updateOrderPrivacyPreferences(data)
        .then(function(response) {
            if(response.status === 200) {
                let data = [
                    {key:'D-1', value: response.data['D-1']},
                    {key:'D-2', value: response.data['D-2']},
                    {key:'D-3', value: response.data['D-3']}
                ]
                form.setOrderPrivacy(data);
            }
        })
        .catch()
}

export default {
    callOrderPrivacy: callOrderPrivacy
}